/**
 * commentStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import * as helpers from '../../utils/helpers';


export default {
    namespaced: true,

    state: {
    // comment
        commentList: [],
        commentLoading: false,
        commentExtra: 0,
        commentQueries: { pagination: 1, pageSize: 12 },
        commentDetail: {},
    },

    mutations: {
        [types.UPDATE_LIST](state, { subject, list }) {
            state[`${subject}List`] = list;
        },
        [types.UPDATE_LOADING_STATUS](state, { subject, isLoading }) {
            state[`${subject}Loading`] = isLoading;
        },
        [types.UPDATE_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        [types.UPDATE_REQUEST_QUERIES](state, { subject, queries }) {
            state[`${subject}Queries`] = queries;
        },
        [types.UPDATE_DETAIL](state, { subject, detail }) {
            state[`${subject}Detail`] = detail;
        },
    },

    actions: {
    // comment: 获取列表
        getCommentList({ commit, state }, queries = {}) {
            const subject = 'comment';
            const {
                pagination = state[`${subject}Queries`].pagination,
                pageSize = state[`${subject}Queries`].pageSize,
                ...otherQueries
            } = queries;
            return new Promise((resolve, reject) => {
                Vue.http.get(urls.GET_COMMENT_LIST, {
                    params: {

                        pageNumber: pageSize,
                        offset: (pagination - 1) * pageSize,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || [];
                    const { total } = response.data;
                    commit(types.UPDATE_LOADING_STATUS, { subject, isLoading: false });
                    commit(types.UPDATE_LIST, { subject, list });
                    commit(types.UPDATE_EXTRA_INFO, { subject, extra: total });
                    commit(types.UPDATE_REQUEST_QUERIES,
                        { subject, queries: { pagination, pageSize, ...otherQueries } });
                    resolve(response);
                }).catch((error) => {
                    commit(types.UPDATE_LOADING_STATUS, { subject, isLoading: false });
                    reject(error);
                });
            });
        },

        // comment: 获取详情
        getcommentDetail({ commit }, { id }) {
            const subject = 'comment';

            return new Promise((resolve, reject) => {
                const url = helpers.buildURL(urls.BASE_URL/* TODO：替换为详情uri，然后删除此注释 */, id);
                Vue.http.get(url).then((response) => {
                    const detail = response.data || {};
                    commit(types.UPDATE_DETAIL, { subject, detail });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        // comment: 更新
        addComment({ dispatch, state }, formData = {}) {
            const subject = 'comment';
            const Subject = subject.replace(/^\w/, _ => _.toUpperCase());
            // var date = new Date();
            // var Y = date.getFullYear() + '-';
            // var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            // var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
            // var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
            // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
            // var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
            //
            // let cDate = Y+M + D+h+m+s;


            const data = helpers.pick(formData, [
                'comment_user',
                'media_id',
                'comment_text',
            ]);
            // data.comment_data = cDate;
            // data=JSON.stringify(data);
            return new Promise((resolve, reject) => {
                const url = helpers.buildURL(urls.ADD_COMMEN);

                Vue.http.post(url, data).then((response) => {
                    dispatch(`get${Subject}List`, state[`${subject}Queries`]);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        // comment: 删除
        deleteComment({ dispatch, state }, { id }) {
            const subject = 'comment';
            const Subject = subject.replace(/^\w/, _ => _.toUpperCase());

            return new Promise((resolve, reject) => {
                const url = helpers.buildURL(urls.RESOLVE_COMMENT, id);
                Vue.http.delete(url).then((response) => {
                    dispatch(`get${Subject}List`, state[`${subject}Queries`]);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        // 批量删除
        bulkDeleteComment({ dispatch, state }, ids) {
            const subject = 'comment';
            const Subject = subject.replace(/^\w/, _ => _.toUpperCase());

            return new Promise((resolve, reject) => {
                const url = helpers.buildURL(urls.BULK_COMMENT_DELETE);
                Vue.http.delete(url, { data: { ids } }).then((response) => {
                    dispatch(`get${Subject}List`, state[`${subject}Queries`]);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    // end of actions
    },
};
